import React, { useState } from 'react';
import UpgradePlanErrorModal from '../../../../../../../shared/components/upgrade-plan-error-modal';
import Button from '../../../../../../../shared/design-system/components/atoms/button';
import DropDownAtom from '../../../../../../../shared/design-system/components/atoms/dropdown';
import { ResourceIdentifiers } from '../../../../../../../shared/utils/access-control/enums/resource-identifiers';
import hasResource from '../../../../../../../shared/utils/access-control/has-resource';
import ImportContactsModal from '../../../../../../sequence/components/sequence-single-content/components/sequence-single-contacts/components/import-contacts-modal';
import AddProspectManuallyModal from '../../modals/add-prospect-manually-modal';
import RestrictionErrorModal from '../../modals/restriction-error-modal';
import {
  getRestrictionPlanModalBodyContent,
  getRestrictionPlanWarningEmailBody,
} from '../../../utils/helper';
import { starterPlanRestriction } from '../../../../../../../shared/utils/plan-restriction';
import { riskyProspectWarningconstants } from '../../../../../../sequence/components/sequence-single-content/components/sequence-single-contacts/components/email-verification/risky-prospect-constant';
import { isFreePlan } from '../../../../../../../shared/utils/plans';
import planPermissionError from '../../../../../../../shared/utils/errors/plan-permission-error';

const AddContactsButton = ({
  fromModule,
  remainingProspectLimit,
  onAddProspectButtonRef = null,
}) => {
  const [showImportContactsModal, setShowImportContactsModal] = useState(false);
  const [
    showAddProspectManuallyModal,
    setShowAddProspectManuallyModal,
  ] = useState(false);
  const [showUpgradePlanErrorModal, setShowUpgradePlanErrorModal] = useState(
    false,
  );
  const [
    isRestrictionModalVisible,
    setIsRestrictionModalVisible,
  ] = useState<boolean>(false);

  //* Show Hide Restriction Error Modal
  const showRestrictionErrorModal = () => setIsRestrictionModalVisible(true);
  const hideRestrictionErrorModal = () => setIsRestrictionModalVisible(false);

  const planUpgradeError = () => {
    const title = 'Please upgrade your plan to start adding prospects';
    const content = [
      'Your account is downgraded to a free plan. Upgrade to paid plan to add prospects and resume email sending.',
    ];

    planPermissionError.showModal(title, content, true);
  };

  const openImportContactsModal = () => {
    if (isFreePlan()) {
      planUpgradeError();
      return;
    }

    if (starterPlanRestriction()) {
      setShowUpgradePlanErrorModal(true);
      return;
    }

    if (parseInt(remainingProspectLimit, 10) === 0) {
      showRestrictionErrorModal();
      return;
    }

    hasResource(ResourceIdentifiers.CONTACTS_IMPORT) &&
      setShowImportContactsModal(true);
  };

  const options = [
    {
      icon: 'software-upload',
      onClick: openImportContactsModal,
      listKey: 'import',
      listLabel: 'Import via CSV',
    },
  ];

  const onAddProspectsButtonClick = () => {
    if (onAddProspectButtonRef) {
      onAddProspectButtonRef.current = true;
    }
    if (isFreePlan()) {
      planUpgradeError();
      return;
    }

    if (starterPlanRestriction()) {
      setShowUpgradePlanErrorModal(true);
      return;
    }

    if (parseInt(remainingProspectLimit, 10) === 0) {
      showRestrictionErrorModal();
      return;
    }

    hasResource(ResourceIdentifiers.CONTACTS_IMPORT) &&
      setShowAddProspectManuallyModal(true);
  };

  return (
    <div className="add-prospect-inner">
      <Button
        variant={Button.Variant.Primary}
        onClick={onAddProspectsButtonClick}
        className="add-prospect-btn"
      >
        Add Prospect
      </Button>
      <DropDownAtom heading="" options={options} />
      {showImportContactsModal && (
        <ImportContactsModal
          warning={riskyProspectWarningconstants.PROSPECT_DEFAULT_WARNING}
          show={showImportContactsModal}
          onClose={() => setShowImportContactsModal(false)}
          fromModule={fromModule}
        />
      )}
      {showAddProspectManuallyModal && (
        <AddProspectManuallyModal
          show={showAddProspectManuallyModal}
          onClose={() => {
            if (onAddProspectButtonRef) {
              onAddProspectButtonRef.current = false;
            }
            setShowAddProspectManuallyModal(false);
          }}
        />
      )}
      {showUpgradePlanErrorModal && (
        <UpgradePlanErrorModal
          show={showUpgradePlanErrorModal}
          onClose={() => {
            if (onAddProspectButtonRef) {
              onAddProspectButtonRef.current = false;
            }
            setShowUpgradePlanErrorModal(false);
          }}
          planName="starter"
          restrictionOn="prospect"
        />
      )}
      {isRestrictionModalVisible && (
        <RestrictionErrorModal
          show={isRestrictionModalVisible}
          onClose={hideRestrictionErrorModal}
          bodyContent={getRestrictionPlanModalBodyContent()}
          emailBody={getRestrictionPlanWarningEmailBody()}
        />
      )}
    </div>
  );
};

export default AddContactsButton;
